import type { OneSdk } from '@/stores/frankie-one.store';

declare global {
  interface Window {
    OneSDK: OneSdk;
  }
}

export class OneSdkLoader {
  private src: string;

  constructor(version: string) {
    this.src = `https://assets.frankiefinancial.io/one-sdk/${version}/oneSdk.umd.js`;
  }

  async getOneSdk(): Promise<OneSdk> {
    if (window.OneSDK) {
      return window.OneSDK;
    }

    return await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = this.src;
      script.onload = () => resolve(window.OneSDK);
      script.onerror = () => reject(new Error(`Failed to load OneSDK from ${this.src}`));
      document.head.appendChild(script);
    });
  }
}
